// extracted by mini-css-extract-plugin
module.exports = {"Pomegranate":"#FF0032","White":"#FFFFFF","wrapper":"Header_wrapper__4Axjt","logo":"Header_logo__3_SJs typography_fontStyleL__3_ZBn"};